<template>
    <v-snackbar v-model="show" :timeout="-1" :transition="false" :class="animate ? 'animate__animated animate__shakeX animate__infinite' : undefined" v-show="!$store.state.missingMemberFields.disabled" color="primary">
        <span class="primarytext--text">{{$translate("We're missing some information about you")}}</span>

        <template v-slot:action="{ attrs }">
            <v-btn
                text
                v-bind="attrs"
                class="zoezi-button-thin primarytext--text"
                @click="showDialog = true"
            >
                {{$translate('Fill in now')}}
            </v-btn>
        </template>

        <v-dialog v-model="showDialog" max-width="500px" scrollable :persistent="persistentDialog" v-if="$store.state.user">
            <v-card>
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        {{$translate('Welcome')}} {{$store.state.user.firstname}}!
                        <v-btn v-if="!persistentDialog" icon @click="showDialog = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="mt-4">{{$translate('We would like to get to know you a little better')}}</div>

                    <v-form v-model="formValid">
                        <form-field v-for="field in missingFields" :key="field.key" :field="field" star v-model="field.value" />
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex pa-2">
                    <v-btn class="zoezi-button-thin flex-grow-1 primarytext--text mr-2" color="primary" :disabled="!formValid" @click="save" :loading="saving">
                        {{$translate('Save')}}
                    </v-btn>
                    <v-btn class="flex-grow-1" outlined color="error" @click="$store.dispatch('logout')">
                        {{$translate('Log out')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-snackbar>
</template>

<script>
import FormField from './FormField.vue';
export default {
    name: 'zoezi-missing-member-fields',
    components: { FormField },

    watch: {
        '$store.state.missingMemberFields.show'(show) {
            this.show = !!show;
            if (show) {
                this.animate = true;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.animate = false;
                    this.timeout = null;
                }, 1000)
            }
        },
        show(show) {
            if (!show) {
                this.$store.state.missingMemberFields.show = false;
            }
        },
        '$store.state.user'() {
            this.checkMissingFields();
        },
        '$store.state.settings.fields'() {
            this.checkMissingFields();
        },
        hasMissingRequiredFields(hasRequired) {
            if (hasRequired) {
                this.showDialog = true;
                this.$store.commit('setCheckoutHidden', true)
            } else {
                this.$store.commit('setCheckoutHidden', false)
            }
        },
        '$store.state.isLoggedIn'(isLoggedIn) {
            if (!isLoggedIn) {
                this.showDialog = false;
                this.$store.commit('showMissingMemberFields', false);
                this.missingFields = null;
            }
        }
    },

    computed: {
        hasMissingRequiredFields() {
            if (this.missingFields && this.missingFields.length) {
                let hasRequired = this.missingFields?.find(x => x.required);
                return !!hasRequired;
            }

            return false;
        },
        persistentDialog() {
            return this.hasMissingRequiredFields;
        }
    },

    data: () => ({
        show: false,
        animate: false,
        timeout: null,
        showDialog: false,
        protectedFields: ['personalCodeNumber', 'phone', 'oldphone', 'city', 'zipCode', 'address', 'extraInfo', 'gender', 'birthdate'],
        missingFields: null,
        formValid: false,
        saving: false
    }),

    methods: {
        checkMissingFields() {
            if (this.showDialog && this.missingFields) {
                return;
            }

            let user = this.$store.state.user;
            let fields = this.$store.state?.settings?.fields;

            if (!user || !fields || user.superUser) {
                return;
            }

            this.missingFields = [];
            let requiredFields = []
            let optionalFields = []
            fields.forEach((field) => {
                if (field.required && field.builtIn && field.name == 'personalCodeNumber' && user.noPcode) {
                    return;
                }

                if (user.isProtected && field.required && field.builtIn && this.protectedFields.indexOf(field.name) != -1) {
                    return;
                }

                if (field.required && field.builtIn && user.company && ['firstname', 'gender', 'birthdate'].indexOf(field.name) != -1) {
                    return;
                }

                let fieldName = field.builtIn ? field.name : 'xf' + field.name;
                if (['password', 'checkbox', 'image'].indexOf(field.type) == -1 && (field.changeable_by_member || (field.required && !field.builtIn)) && !user[fieldName]) {
                    field = Object.assign({}, field, {value: null, key: field.builtIn + field.name});

                    let array = field.required ? requiredFields : optionalFields;
                    array.push(field);
                }
            });

            if (requiredFields.length + optionalFields.length > 0) {
                this.missingFields = requiredFields.concat(optionalFields)
            }
        },
        save() {
            let data = {};
            this.missingFields.forEach(x => {
                if (!x.builtIn) {
                    if (!data.xf) {
                        data.xf = {};
                    }
                    data.xf[x.name] = x.value;
                } else {
                    data[x.name] = x.value;
                }
            })
            this.saving = true;
            this.$api.post('/api/memberapi/change', data).then((response) => {
                this.saving = false;
                if (response.ok) {
                    this.showDialog = false;
                    this.$store.commit('showMissingMemberFields', false);
                } else {
                    response.json().then(data => {
                        let text = this.$translate(data.message);
                        this.$store.commit('showSnackBar', {text});
                    })
                }
            })
        }
    }
}
</script>
